import { useState } from "react";
import global from '../global';
import { showError, showSuccess } from "../utils/helper";
import HeaderTop from "../Components/HeaderTop";
import { checkPrinterConnection, printTestPage } from "../Helpers/receipt";

export default function Printer() {
    const [printerStatus, setPrinterStatus] = useState(null)
    const [checkingPrinter, setCheckingPrinter] = useState(false)
    const [printingTest, setPrintingTest] = useState(false)

    // Check printer connection
    const handleCheckPrinter = async () => {
        setCheckingPrinter(true)
        setPrinterStatus(null)

        const result = await checkPrinterConnection()
        setPrinterStatus(result)
        setCheckingPrinter(false)

        if (result.connected) {
            showSuccess('Printer je spojen i spreman za rad!')
        } else {
            showError('Printer nije spojen: ' + (result.error || result.status))
        }
    }

    // Print test page
    const handleTestPrint = async () => {
        setPrintingTest(true)

        const result = await printTestPage()
        setPrintingTest(false)

        if (result.success) {
            showSuccess('Testna stranica je uspješno ispisana!')
        } else {
            showError('Greška pri ispisu: ' + result.error)
        }
    }

    return (
        <>
            <HeaderTop title={'Printer'} />
            <div className="w-full h-full flex flex-column" style={{ minHeight: `calc(100vh - 80px)` }}>
                <div className="w-full flex-grow flex">
                    <div className="flex flex-col bg-blue-gray-50 h-full w-full">
                        <div className="h-full overflow-hidden mt-4 flex">
                            <div className="w-1/2 flex flex-col bg-blue-gray-50 h-full bg-white pr-2 pl-4 mb-4">
                                <div className="bg-white rounded-sm flex flex-col h-fit shadow px-4 py-4 mb-4">
                                    <div className="px-4 sm:px-0">
                                        <h3 className="text-2xl font-semibold leading-7 text-gray-900">Status printera</h3>
                                        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                                            Provjera povezanosti termalnog printera
                                        </p>
                                        <p className="mt-1 max-w-2xl text-xs leading-5 text-yellow-600">
                                            Napomena: Točnost provjere ovisi o printer driveru. Za najbolju provjeru koristite testni ispis.
                                        </p>
                                    </div>
                                    <div className="mt-6 border-t border-gray-100">
                                        <dl className="divide-y divide-gray-100">
                                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <dt className="text-sm font-medium leading-6 text-gray-900">Blagajna</dt>
                                                <dd className="mt-1 text-sm leading-6 text-gray-700 font-bold">
                                                    {global.invoiceDevice?.invoice_space_name || '-'} ({global.invoiceDevice?.invoice_space_label}-{global.invoiceDevice?.label})
                                                </dd>
                                            </div>
                                            <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                <dt className="text-sm font-medium leading-6 text-gray-900">Status</dt>
                                                <dd className="mt-1 text-sm leading-6 font-bold">
                                                    {printerStatus === null ? (
                                                        <span className="text-gray-500">Nije provjereno</span>
                                                    ) : printerStatus.connected ? (
                                                        <span className="text-green-600 flex items-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                            </svg>
                                                            {printerStatus.status}
                                                        </span>
                                                    ) : (
                                                        <span className="text-red-600 flex items-center">
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                                                            </svg>
                                                            {printerStatus.status}
                                                        </span>
                                                    )}
                                                </dd>
                                            </div>
                                            {printerStatus?.error && (
                                                <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                    <dt className="text-sm font-medium leading-6 text-gray-900">Greška</dt>
                                                    <dd className="mt-1 text-sm leading-6 text-red-600 font-bold">
                                                        {printerStatus.error}
                                                    </dd>
                                                </div>
                                            )}
                                            <div className="px-4 py-6 sm:px-0">
                                                <button
                                                    onClick={handleCheckPrinter}
                                                    disabled={checkingPrinter}
                                                    className="bg-blue-600 hover:bg-blue-800 disabled:bg-blue-300 text-white py-2 px-4 rounded inline-flex items-center mr-2"
                                                >
                                                    {checkingPrinter ? (
                                                        <>
                                                            <svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                            </svg>
                                                            Provjera...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z" clipRule="evenodd" />
                                                            </svg>
                                                            Provjeri printer
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </dl>
                                    </div>
                                </div>
                            </div>

                            <div className="w-1/2 flex flex-col bg-blue-gray-50 h-full bg-white pr-4 pl-2 mb-4">
                                <div className="bg-white rounded-sm flex flex-col h-fit shadow px-4 py-4 mb-4">
                                    <div className="px-4 sm:px-0">
                                        <h3 className="text-2xl font-semibold leading-7 text-gray-900">Testni ispis</h3>
                                        <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                                            Ispis testne stranice za provjeru rada printera
                                        </p>
                                    </div>
                                    <div className="mt-6 border-t border-gray-100">
                                        <dl className="divide-y divide-gray-100">
                                            <div className="px-4 py-6 sm:px-0">
                                                <div className="bg-blue-50 border border-blue-200 rounded-md p-3 mb-4">
                                                    <p className="text-sm text-blue-800 font-medium">
                                                        Najpouzdaniji način provjere printera je testni ispis.
                                                    </p>
                                                    <p className="text-xs text-blue-600 mt-1">
                                                        Ako se papir ispiše, printer radi ispravno.
                                                    </p>
                                                </div>
                                                <p className="text-sm text-gray-600 mb-4">
                                                    Testna stranica će ispisati:
                                                </p>
                                                <ul className="text-sm text-gray-600 list-disc list-inside mb-6">
                                                    <li>Naziv blagajne</li>
                                                    <li>Trenutni datum i vrijeme</li>
                                                    <li>Test znakova (uključujući hrvatska slova)</li>
                                                    <li>Test linija</li>
                                                </ul>
                                                <button
                                                    onClick={handleTestPrint}
                                                    disabled={printingTest}
                                                    className="bg-green-600 hover:bg-green-800 disabled:bg-green-300 text-white py-2 px-4 rounded inline-flex items-center"
                                                >
                                                    {printingTest ? (
                                                        <>
                                                            <svg className="animate-spin h-5 w-5 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                                            </svg>
                                                            Ispisuje se...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
                                                                <path fillRule="evenodd" d="M5 4v3H4a2 2 0 00-2 2v3a2 2 0 002 2h1v2a2 2 0 002 2h6a2 2 0 002-2v-2h1a2 2 0 002-2V9a2 2 0 00-2-2h-1V4a2 2 0 00-2-2H7a2 2 0 00-2 2zm8 0H7v3h6V4zm0 8H7v4h6v-4z" clipRule="evenodd" />
                                                            </svg>
                                                            Ispis testne stranice
                                                        </>
                                                    )}
                                                </button>
                                            </div>
                                        </dl>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
